import React, { Dispatch, SetStateAction } from "react";
import { ProjectCardInter } from "../../interface/interface";
import { formatDateTime } from "../../lib/lib";
import FixBtn from "../FixBtn/FixBtn";
import PostDeleteSection from "../PostDeleteSection/PostDeleteSection";

type Props = {
  index: number;
  PostRemove: ((data: any, id: string) => void) | ((id: string) => void);
  setDeleteIndex: Dispatch<SetStateAction<string | undefined>>;
  DeleteIndex: string | undefined;
  data: ProjectCardInter;
};

const SaveCard = ({
  index,
  PostRemove,
  setDeleteIndex,
  DeleteIndex,
  data,
}: Props) => {
  const { prjt_nm, prjt_apply_st_at, prjt_id, prjt_type_cd, prjt_sts_cd } =
    data;
  return (
    <div className="save-card-comp">
      <div className="save-title ">{prjt_nm}</div>
      <div className="save-time">
        {prjt_apply_st_at
          ? formatDateTime(new Date(prjt_apply_st_at).getTime(), "-")
          : "-"}
      </div>
      <div className="save-card-fix-btn">
        <FixBtn
          link={`/${prjt_type_cd}/write/step/1`}
          state={{ prjt_id, prjt_sts_cd }}
          style={{
            color: "white",
            backgroundColor: "#0062ff",
          }}
        />
      </div>
      <PostDeleteSection
        isOpen={DeleteIndex === data.prjt_id}
        ment="프로젝트를 삭제하시겠습니까?"
        index={data.prjt_id}
        setDeleteIndex={setDeleteIndex}
        data={prjt_id}
        PostRemove={PostRemove}
      />
    </div>
  );
};

export default SaveCard;
